import React, { useEffect, useRef, useState } from "react";
import { FaceMesh } from "@mediapipe/face_mesh";
import { Camera } from "@mediapipe/camera_utils";
import { jwtDecode } from "jwt-decode";
import "../css/unggahwajah.css"; // Import CSS

const UnggahWajah = () => {
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [modelsLoaded, setModelsLoaded] = useState(false);
  const [faceDetected, setFaceDetected] = useState(false);
  const [faceEmbedding, setFaceEmbedding] = useState(null);
  const [sending, setSending] = useState(false);
  const [message, setMessage] = useState("");
  const token = localStorage.getItem("token");
  const { id } = jwtDecode(token);

  useEffect(() => {
    if (!videoRef.current) return;

    const faceMesh = new FaceMesh({
      locateFile: (file) =>
        `https://cdn.jsdelivr.net/npm/@mediapipe/face_mesh/${file}`,
    });

    faceMesh.setOptions({
      maxNumFaces: 1,
      refineLandmarks: true,
      minDetectionConfidence: 0.5,
      minTrackingConfidence: 0.5,
    });

    faceMesh.onResults((results) => {
      if (results.multiFaceLandmarks.length > 0) {
        setFaceDetected(true);
        const landmarks = results.multiFaceLandmarks[0];
        setFaceEmbedding(extractEmbedding(landmarks));
        drawFaceMesh(landmarks);
      } else {
        setFaceDetected(false);
        setFaceEmbedding(null);
      }
    });

    setTimeout(() => {
      if (videoRef.current) {
        const camera = new Camera(videoRef.current, {
          onFrame: async () => {
            await faceMesh.send({ image: videoRef.current });
          },
          width: 640,
          height: 480,
        });
        camera.start();
        setModelsLoaded(true);
      }
    }, 500);
  }, []);

  const extractEmbedding = (landmarks) => {
    return landmarks.map((point) => [point.x, point.y, point.z]);
  };

  const drawFaceMesh = (landmarks) => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.strokeStyle = "#00FF00";
    ctx.lineWidth = 2;

    landmarks.forEach((point) => {
      ctx.beginPath();
      ctx.arc(
        point.x * canvas.width,
        point.y * canvas.height,
        2,
        0,
        2 * Math.PI
      );
      ctx.fillStyle = "red";
      ctx.fill();
      ctx.closePath();
    });
  };

  const handleUpload = async () => {
    if (!faceEmbedding || !id) {
      setMessage("Gagal mengirim: Data tidak lengkap.");
      return;
    }

    setSending(true);
    setMessage("");

    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}/api/uploadyourface/upload-face`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            id: id,
            face_descriptor: faceEmbedding,
          }),
        }
      );

      if (response.ok) {
        setMessage("✅ Data wajah berhasil dikirim!");
      } else {
        setMessage("❌ Gagal mengirim data.");
      }
    } catch (error) {
      console.error("Error:", error);
      setMessage("⚠ Terjadi kesalahan saat mengirim data.");
    }

    setSending(false);
  };

  return (
    <div className="unggah-wajah-container">
      <h2>Upload Wajah</h2>
      {!modelsLoaded && <p>⏳ Memuat model deteksi wajah...</p>}

      <div className="video-container">
        <video
          ref={videoRef}
          autoPlay
          playsInline
          width="640"
          height="480"
        ></video>
        <canvas ref={canvasRef} width="640" height="480"></canvas>
      </div>

      {faceDetected ? (
        <>
          <p className="face-detected">✔ Wajah terdeteksi!</p>
          <button
            onClick={handleUpload}
            disabled={sending}
            className="kirim-button"
          >
            {sending ? "Mengirim..." : "Kirim"}
          </button>
        </>
      ) : (
        <p className="face-not-detected">❌ Wajah tidak terdeteksi.</p>
      )}

      {message && <p className="message">{message}</p>}
    </div>
  );
};

export default UnggahWajah;
